import playlistGroupThumbnail from './PlaylistGroupThumbnail'
import playlistGroupCard from './PlaylistGroupCard'

export default {
  install(Vue) {
    Vue.component('browse-home', () => import(/* webpackChunkName: "browse" */ './BrowseHome'))
    Vue.component('playlist', () => import(/* webpackChunkName: "browse" */ './Playlist'))
    Vue.component('playlist-group', () => import(/* webpackChunkName: "browse" */ './PlaylistGroup'))
    // Vue.component('playlist-group-thumbnail', () => import(/* webpackChunkName: "browse" */ './PlaylistGroupThumbnail'))
    Vue.component('segment', () => import(/* webpackChunkName: "browse" */ './Segment'))
    Vue.component('onboarding', () => import(/* webpackChunkName: "browse" */ './Onboarding'))
    Vue.component('playlist-group-card', playlistGroupCard)
    Vue.component('playlist-group-thumbnail', playlistGroupThumbnail)
  }
}
